import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import tagAction from '../../actions/tag.action';
import { parseEvaluation, useTags } from '../../helpers/tag.helpper';
import { bsTiny } from '../../helpers/ui.helper';
import useDispatch from '../../hooks/useDispatch';
import useSelector from '../../hooks/useSelector';
import LoadingImage from '../general/LoadingImage';

const Styles = styled.div`
  margin-bottom: 0.5rem;
  .tag-button {
    margin-right: 1rem;
  }
`;

interface Props {
  tickersWithCategory: Set<string>;
}

const TagSelector: React.FC<Props> = ({ tickersWithCategory }) => {
  const {
    getStockTags: { loading, tags, stocksByTag },
    selected,
  } = useSelector(state => state.tag);

  const dispatch = useDispatch();

  const [t, i18n] = useTranslation();

  useTags();

  if (tags && tags.length === 0) {
    return null;
  }

  return (
    <Styles>
      <small>{t('tags')}: </small>
      <LoadingImage loading={loading} />
      {tags &&
        tags
          .filter(tag => stocksByTag[tag.id])
          .map(tag => {
            if (tag.evaluation) {
              const evalFn = parseEvaluation(tag.evaluation);
              return {
                tag,
                count: [...tickersWithCategory].filter(evalFn).length,
              };
            }
            return {
              tag,
              count: [...tickersWithCategory].filter(tickerWithCategory =>
                stocksByTag[tag.id].has(tickerWithCategory)
              ).length,
            };
          })
          .filter(({ count }) => count)
          .map(({ tag, count }) => (
            <Button
              className="tag-button"
              size={bsTiny}
              variant={selected === tag.id ? 'dark' : 'light'}
              key={tag.id}
              onClick={() => {
                dispatch(
                  tagAction.selectTag(selected === tag.id ? '' : tag.id)
                );
              }}
            >
              {tag['name_' + i18n.language]}{' '}
              <Badge bg={selected === tag.id ? 'secondary' : 'dark'}>
                {count}
              </Badge>
            </Button>
          ))}
    </Styles>
  );
};

export default TagSelector;
